// extracted by mini-css-extract-plugin
export default {"register":"SetPassword_register__Rq+Ra","registerHeader":"SetPassword_registerHeader__rYD87","registerBody":"SetPassword_registerBody__mh4Ux"};